export const OnlyPublicApiPaths = [
  '/login/refresh',
  '/login',
  '/resetPassword',
  '/resetPassword/requestToken',
  '/resetPassword/token/',
  '/resetPassword/reset',
];

export const PublicApiPaths = [
  ...OnlyPublicApiPaths,
  '/signup',
  '/register',
  '/register/token',
];
